import { useMutation } from 'react-query';
import AuthAPI from 'services/API/AuthAPI';

export const useForgotPassword = () => {
  const { mutate, mutateAsync, isLoading, isError, isSuccess, data, error, reset } =
    useMutation(async (email: string) => {
      const response = await AuthAPI.postRequestPasswordReset({ email });

      return response;
    });

  return { mutate, mutateAsync, isLoading, isError, isSuccess, data, error, reset };
};
